import { BillingExplorerWidgetSetupType } from "../types/setups/billingExplorerSetupType";

export const billingExplorerWidgetSetupDefaultData: BillingExplorerWidgetSetupType =
  {
    widgetType: "cost_breakdown",
    //TODO: EnableWidgetsSideBarConfigurations, remove viewType
    viewType: "stacked_column",
    visualization: {
      series: 10,
      trend: true,
      scale: "linear",
      show_legends: true,
      region_column: true,
      account_column: true,
      forecasted_cost: true,
      cumulative_line: false,
      show_data_labels: true,
      display_forecast: false,
      chart_base_type: "cost",
      previous_period_cost: true,
      chart_type: "stacked_column",
    },
    aggregation: {
      total_cost: true,
      daily_average: true,
      forecasted_cost: true,
      live_filtered: true,
    },
    trendType: "month_over_month",
    frequency: "monthly",
    name: "Billing Explorer",
    dates: { label: "past_fourteen_days" },
    inheritDates: true,
    grouping: "service",
    group_values: null,
    viewId: undefined,
    forecastOption: "month",
  };
